import React from "react";
import { NavLink,useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import { useLanguage } from "@src/context/LanguageContext";
import secureStorage from "@src/config/encrypt";
import { toast } from "react-toastify"; 
import { useDispatch } from "react-redux";
import { Accordion, Card, Button, DropdownButton, Dropdown } from "react-bootstrap";
import { MANAGER_LEVEL_IDS,REMITTANCE_LEVEL_IDS,COUNTRY_CODE,APP_COUNTRY } from '../../src/config/constant';
import * as HELPER from "../../src/config/helper";


const LOGO =  require('../styles/webroot/images/zenIns.png');

//import logo from "../styles/webroot/images/Logo.png"

const Navigation = (props:any) => {
    const [role, setRole] = useState("");
    // eslint-disable-next-line
    const [isMount, setIsMount] = useState(false);
    // eslint-disable-next-line
    const [redirect, setRedirect] = useState(false);
    const [name, setName] = useState("");
    const navigate = useNavigate();
    const { translations} = useLanguage();

    useEffect(() => {
        setIsMount(true);
        let result = secureStorage.getItem("authUserInfo");

        if (!result) {
             setRedirect(true)
        } else {
            let userInfo = result.user_data;
            setName((userInfo && userInfo.name) || '');
            setRole((userInfo && userInfo.assigned_role_name) || '');

        }

        // if (prevTranslationsRef.current !== translations) {
        //     dispatch(getMasterConfig());
        //     prevTranslationsRef.current = translations;
        // }
        // eslint-disable-next-line
    },[translations]);

    const logOutUser = async () => {
        let result = secureStorage.getItem("authUserInfo")
        if (result) {
            secureStorage.removeItem("authUserInfo")
            toast.success('LogOut Successfully')
            setTimeout(()=> { navigate('/login');  },100)
        }
    };

    const authUserInfo = secureStorage.getItem("authUserInfo");

    const redirectToDashboard = () => {
        //navigate('/lead-list');
        HELPER.navigatePermssion(navigate);
    };
    
    return (
        <div className="container-fluid" >
            <div className="header-main">
                <div className="logo logo-text">
                <img src={LOGO} alt="" style={{cursor: 'pointer'}} onClick={() => redirectToDashboard()}/>
                <span>Collection Box</span>
                </div>
                <div className="right-panel-naviganion menupanel">
                    <div className="nav">
                        <ul>
                            {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && (
                                <>
                                    <li><NavLink to="/lead-list">{translations.Navigation?.['Leads'] || translations.commonMsg?.loading}</NavLink></li>
                                    <li><NavLink to="/remittance-list">{translations.Navigation?.['Remittance'] || translations.commonMsg?.loading}</NavLink></li>
                                    {/* <li><NavLink to="#">Reports</NavLink></li> */}
                           
                                    <li className="dropdownmenu"><NavLink to="#">{translations.Navigation?.['More'] || translations.commonMsg?.loading}</NavLink>
                                        <ul className="submenu">
                                            <li><NavLink to="/rule-engine">{translations.Navigation?.['Rule Engine'] || translations.commonMsg?.loading}</NavLink> </li>
                                            {
                                                COUNTRY_CODE === APP_COUNTRY.APP_TYPE_ID && 
                                                <>
                                                    <li><NavLink to="/config">{translations?.Navigation?.['CONFIG'] || translations.commonMsg?.loading}</NavLink> </li>
                                                </>
                                            }
                                        </ul>
                                    </li>

                                    <li className="dropdownmenu"><NavLink to="#">{translations.Navigation?.['Admin'] || translations.commonMsg?.loading}</NavLink>
                                        <ul className="submenu">
                                            <li><NavLink to="/lead-list">{translations.Navigation?.['Collections'] || translations.commonMsg?.loading}</NavLink> </li>
                                            {
                                                COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH && 
                                                <>
                                                    <li><NavLink to="/payment-list">{translations.Navigation?.['Finance'] || translations.commonMsg?.loading}</NavLink> </li>
                                                    <li><NavLink to="/reconciliation-list">{translations.Navigation?.['Reconciliation'] || translations.commonMsg?.loading}</NavLink> </li>
                                                </>
                                            }
                                        </ul>
                                    </li>
                                </>
                            )}
                            {REMITTANCE_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && (
                                <>
                                    <li><NavLink to="/remittance-list">{translations.Navigation?.['Remittance'] || translations.commonMsg?.loading}</NavLink></li>
                                </>
                            )}
                        </ul>
                    </div>
                    

                    <div className="user-detail ">
                        <ul>

                            <li className="dropdownmenu"><NavLink to="#">
                                <span className="userarc">
                                    {name[0]?.toUpperCase()}
                                </span>
                                <div className="username">
                                    <span>{name}</span>
                                    <span className="user-degintion" title={role}>{role.length>10 ? role.substr(0, 10)+'...' : role}</span>
                                </div>
                            </NavLink>
                                <ul className="submenu ht-logout">
                                    <li><NavLink to="#" onClick={logOutUser}>{translations.Navigation?.['Logout'] || translations.commonMsg?.loading}</NavLink> </li>
                                </ul>
                            </li>

                        </ul>
                    </div>
                
                </div>

            </div>

        </div >
    );
    
}



export default Navigation;